
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lawKK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f693f033a1373d3c$export$2e2bcd8739ae039; });

var $j7Iem = parcelRequire("j7Iem");

var $8Aq0Q = parcelRequire("8Aq0Q");

var $byC10 = parcelRequire("byC10");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $hdvAu = parcelRequire("hdvAu");

var $btjy5 = parcelRequire("btjy5");

var $bJ4Xk = parcelRequire("bJ4Xk");

var $34TA1 = parcelRequire("34TA1");
function $f693f033a1373d3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f693f033a1373d3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f693f033a1373d3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $j7Iem.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f693f033a1373d3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f693f033a1373d3c$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    maxWidth: '100%',
    minHeight: '0%',
    flexBasis: '100%',
    flexDirection: 'column',
    flexGrow: 1
});
var $f693f033a1373d3c$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "@atlaskit/tabs",
    packageVersion: "13.4.9"
};
var $f693f033a1373d3c$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && (0, $3dJ4i.jsx)((0, $btjy5.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            'aria-labelledby': "".concat(tabsId, "-").concat(index),
            onMouseDown: (0, $34TA1.onMouseDownBlur),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $f693f033a1373d3c$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useGlobalTheme = (0, $hdvAu.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var _useState = (0, $1oC0p.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, $byC10.default)(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $1oC0p.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, $8Aq0Q.default)(childrenArray), tabList = _childrenArray[0], tabPanels = _childrenArray.slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $1oC0p.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $1oC0p.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $gJJny.usePlatformLeafEventHandler)($f693f033a1373d3c$var$_objectSpread({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $f693f033a1373d3c$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $f693f033a1373d3c$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $f693f033a1373d3c$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    var tabsStyles = (0, $1oC0p.useMemo)(function() {
        return (0, $bJ4Xk.getTabsStyles)(mode);
    }, [
        mode
    ]);
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    (0, $3dJ4i.jsx)("div", {
        "data-testid": testId,
        css: [
            $f693f033a1373d3c$var$baseStyles,
            tabsStyles
        ]
    }, (0, $3dJ4i.jsx)((0, $btjy5.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, tabPanelsWithContext)));
};
var $f693f033a1373d3c$export$2e2bcd8739ae039 = $f693f033a1373d3c$var$Tabs;

});
parcelRegister("j7Iem", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dec0fb12a6d80200$export$2e2bcd8739ae039; });

var $1Is3D = parcelRequire("1Is3D");
function $dec0fb12a6d80200$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $1Is3D.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("1Is3D", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13ffaa29f3e72dda$export$2e2bcd8739ae039; });

var $6SGpS = parcelRequire("6SGpS");

var $iGtKL = parcelRequire("iGtKL");
function $13ffaa29f3e72dda$export$2e2bcd8739ae039(t) {
    var i = (0, $iGtKL.default)(t, "string");
    return "symbol" == (0, $6SGpS.default)(i) ? i : i + "";
}

});
parcelRegister("6SGpS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5028b03d47610007$export$2e2bcd8739ae039; });
function $5028b03d47610007$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5028b03d47610007$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5028b03d47610007$export$2e2bcd8739ae039(o);
}

});

parcelRegister("iGtKL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9a33a9952a28b73$export$2e2bcd8739ae039; });

var $6SGpS = parcelRequire("6SGpS");
function $d9a33a9952a28b73$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6SGpS.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6SGpS.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("8Aq0Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6405dd1367361b80$export$2e2bcd8739ae039; });

var $9KY7p = parcelRequire("9KY7p");

var $5QptS = parcelRequire("5QptS");

var $e8Voo = parcelRequire("e8Voo");

var $cHARL = parcelRequire("cHARL");
function $6405dd1367361b80$export$2e2bcd8739ae039(r) {
    return (0, $9KY7p.default)(r) || (0, $5QptS.default)(r) || (0, $e8Voo.default)(r) || (0, $cHARL.default)();
}

});
parcelRegister("9KY7p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $71a70b38d303abc3$export$2e2bcd8739ae039; });
function $71a70b38d303abc3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("5QptS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44159310e7a1e433$export$2e2bcd8739ae039; });
function $44159310e7a1e433$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("e8Voo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4be54f9b16ccc80$export$2e2bcd8739ae039; });

var $gzFz8 = parcelRequire("gzFz8");
function $a4be54f9b16ccc80$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gzFz8.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gzFz8.default)(r, a) : void 0;
    }
}

});
parcelRegister("gzFz8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c110284c081a3195$export$2e2bcd8739ae039; });
function $c110284c081a3195$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("cHARL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $93f6190cbc02d0d6$export$2e2bcd8739ae039; });
function $93f6190cbc02d0d6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("byC10", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $86a05bb24d4182bc$export$2e2bcd8739ae039; });

var $9KY7p = parcelRequire("9KY7p");

var $8wcBx = parcelRequire("8wcBx");

var $e8Voo = parcelRequire("e8Voo");

var $cHARL = parcelRequire("cHARL");
function $86a05bb24d4182bc$export$2e2bcd8739ae039(r, e) {
    return (0, $9KY7p.default)(r) || (0, $8wcBx.default)(r, e) || (0, $e8Voo.default)(r, e) || (0, $cHARL.default)();
}

});
parcelRegister("8wcBx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $633b16db9548e32f$export$2e2bcd8739ae039; });
function $633b16db9548e32f$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});


parcelRegister("hdvAu", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $c88c272cbfedcd20$export$7692396083754928; });

var $XxKRx = parcelRequire("XxKRx");
// Create default global light theme
var $c88c272cbfedcd20$var$_createTheme = (0, $XxKRx.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $c88c272cbfedcd20$var$Provider = $c88c272cbfedcd20$var$_createTheme.Provider, $c88c272cbfedcd20$var$Consumer = $c88c272cbfedcd20$var$_createTheme.Consumer, $c88c272cbfedcd20$export$7692396083754928 = $c88c272cbfedcd20$var$_createTheme.useTheme;
var $c88c272cbfedcd20$export$2e2bcd8739ae039 = {
    Provider: $c88c272cbfedcd20$var$Provider,
    Consumer: $c88c272cbfedcd20$var$Consumer
};

});
parcelRegister("XxKRx", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $0b2fb1cfed45ef9a$export$25d302a5b900a763; });

var $lqqfW = parcelRequire("lqqfW");

var $1oC0p = parcelRequire("1oC0p");
var $0b2fb1cfed45ef9a$var$_excluded = [
    "children"
];
function $0b2fb1cfed45ef9a$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $lqqfW.default)(props, $0b2fb1cfed45ef9a$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("lqqfW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f99064943d659d9b$export$2e2bcd8739ae039; });

var $f5kkK = parcelRequire("f5kkK");
function $f99064943d659d9b$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $f5kkK.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("f5kkK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $afb7187aa6028664$export$2e2bcd8739ae039; });
function $afb7187aa6028664$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("btjy5", function(module, exports) {
$parcel$export(module.exports, "TabContext", function () { return $85a1911bdf59ecbd$export$5a5d356ca5f10a0a; });
$parcel$export(module.exports, "TabListContext", function () { return $85a1911bdf59ecbd$export$aa6907f9fd69e93b; });
$parcel$export(module.exports, "TabPanelContext", function () { return $85a1911bdf59ecbd$export$2054129d247c3102; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $85a1911bdf59ecbd$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $85a1911bdf59ecbd$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $85a1911bdf59ecbd$export$2054129d247c3102 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("bJ4Xk", function(module, exports) {
$parcel$export(module.exports, "getTabsStyles", function () { return $8897bdcf3df5d3c2$export$dd5afd2190fb792c; });
$parcel$export(module.exports, "getTabListStyles", function () { return $8897bdcf3df5d3c2$export$42a3c683c377bcb2; });

var $j7Iem = parcelRequire("j7Iem");

var $3dJ4i = parcelRequire("3dJ4i");

var $6w3Ij = parcelRequire("6w3Ij");
function $8897bdcf3df5d3c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8897bdcf3df5d3c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8897bdcf3df5d3c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $j7Iem.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8897bdcf3df5d3c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8897bdcf3df5d3c2$var$tabLeftRightPadding = "var(--ds-space-100, 8px)";
var $8897bdcf3df5d3c2$var$tabTopBottomPadding = "var(--ds-space-050, 4px)";
// TODO this should probably be `border.width.indicator`
var $8897bdcf3df5d3c2$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
var $8897bdcf3df5d3c2$var$highContrastFocusStyles = {
    outline: "var(--ds-border-width, 1px)".concat(" solid")
};
// Required so the focus ring is visible in high contrast mode
var $8897bdcf3df5d3c2$var$highContrastFocusRing = {
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': $8897bdcf3df5d3c2$var$highContrastFocusStyles,
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$highContrastFocusStyles
        }
    }
};
var $8897bdcf3df5d3c2$var$tabFocusStyles = function tabFocusStyles(mode) {
    return {
        boxShadow: "0 0 0 2px ".concat((0, $6w3Ij.getTabPanelFocusColor)(mode), " inset"),
        borderRadius: "var(--ds-border-radius, 3px)",
        outline: 'none'
    };
};
var $8897bdcf3df5d3c2$var$getTabPanelStyles = function getTabPanelStyles(mode) {
    return $8897bdcf3df5d3c2$var$_objectSpread({
        flexGrow: 1,
        /*
      NOTE min-height set to 0% because of Firefox bug
      FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
    */ minHeight: '0%',
        display: 'flex',
        padding: "0 ".concat($8897bdcf3df5d3c2$var$tabLeftRightPadding),
        '&:focus-visible': $8897bdcf3df5d3c2$var$tabFocusStyles(mode),
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$tabFocusStyles(mode)
        }
    }, $8897bdcf3df5d3c2$var$highContrastFocusRing);
};
var $8897bdcf3df5d3c2$export$dd5afd2190fb792c = function getTabsStyles(mode) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $3dJ4i.css)({
        '& [role="tabpanel"]': $8897bdcf3df5d3c2$var$getTabPanelStyles(mode),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '& > [hidden]': {
            display: 'none'
        }
    }));
};
var $8897bdcf3df5d3c2$var$tabLineStyles = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    left: $8897bdcf3df5d3c2$var$tabLeftRightPadding,
    right: $8897bdcf3df5d3c2$var$tabLeftRightPadding
};
var $8897bdcf3df5d3c2$export$42a3c683c377bcb2 = function getTabListStyles(mode) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $3dJ4i.css)({
        '& [role="tab"]': $8897bdcf3df5d3c2$export$916c8b0fccbb37d2(mode),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        '&::before': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
            height: $8897bdcf3df5d3c2$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            backgroundColor: (0, $6w3Ij.getTabLineColor)(mode).lineColor
        })
    }));
};
var $8897bdcf3df5d3c2$var$tabPanelFocusStyles = function tabPanelFocusStyles(mode) {
    var colors = (0, $6w3Ij.getTabColors)(mode);
    return {
        boxShadow: "0 0 0 2px ".concat(colors.focusBorderColor, " inset"),
        borderRadius: "var(--ds-border-radius, 3px)",
        outline: 'none',
        // Hide TabLine on focus
        '&::after': {
            opacity: 0
        }
    };
};
var $8897bdcf3df5d3c2$export$916c8b0fccbb37d2 = function getTabStyles(mode) {
    var colors = (0, $6w3Ij.getTabColors)(mode);
    return $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({
        color: colors.labelColor,
        cursor: 'pointer',
        lineHeight: 1.8,
        margin: 0,
        padding: "".concat($8897bdcf3df5d3c2$var$tabTopBottomPadding, " ").concat($8897bdcf3df5d3c2$var$tabLeftRightPadding),
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).hoveredColor),
                height: 0
            })
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).activeColor),
                height: 0
            })
        },
        '&:focus-visible': $8897bdcf3df5d3c2$var$tabPanelFocusStyles(mode),
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$tabPanelFocusStyles(mode)
        }
    }, $8897bdcf3df5d3c2$var$highContrastFocusRing), {}, {
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                // This line is a border so it is visible in high contrast mode
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).selectedColor),
                height: 0
            })
        }
    });
};

});
parcelRegister("6w3Ij", function(module, exports) {
$parcel$export(module.exports, "getTabColors", function () { return $4be89cb811b70b40$export$8a53023232713127; });
$parcel$export(module.exports, "getTabLineColor", function () { return $4be89cb811b70b40$export$eff40d6a7c078cf; });
$parcel$export(module.exports, "getTabPanelFocusColor", function () { return $4be89cb811b70b40$export$5b33c784b26b1d3f; });

var $9ALL1 = parcelRequire("9ALL1");
var $4be89cb811b70b40$var$tabColorMap = {
    light: {
        labelColor: "var(--ds-text-subtle, ".concat((0, $9ALL1.N500), ")"),
        activeLabelColor: "var(--ds-text, ".concat((0, $9ALL1.B500), ")"),
        hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $9ALL1.B400), ")"),
        selectedColor: "var(--ds-text-selected, ".concat((0, $9ALL1.B400), ")"),
        focusBorderColor: "var(--ds-border-focused, ".concat((0, $9ALL1.B100), ")")
    },
    dark: {
        labelColor: "var(--ds-text-subtle, ".concat((0, $9ALL1.DN400), ")"),
        activeLabelColor: "var(--ds-text, ".concat((0, $9ALL1.B200), ")"),
        hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $9ALL1.B75), ")"),
        selectedColor: "var(--ds-text-selected, ".concat((0, $9ALL1.B75), ")"),
        focusBorderColor: "var(--ds-border-focused, ".concat((0, $9ALL1.B75), ")")
    }
};
var $4be89cb811b70b40$export$8a53023232713127 = function getTabColors(mode) {
    return $4be89cb811b70b40$var$tabColorMap[mode];
};
var $4be89cb811b70b40$var$tabLineColorMap = {
    light: {
        lineColor: "var(--ds-border, ".concat((0, $9ALL1.N30), ")"),
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: "var(--ds-border-selected, ".concat((0, $9ALL1.B400), ")")
    },
    dark: {
        lineColor: "var(--ds-border, ".concat((0, $9ALL1.DN0), ")"),
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: "var(--ds-border-selected, ".concat((0, $9ALL1.B75), ")")
    }
};
var $4be89cb811b70b40$export$eff40d6a7c078cf = function getTabLineColor(mode) {
    return $4be89cb811b70b40$var$tabLineColorMap[mode];
};
var $4be89cb811b70b40$var$tabPanelFocusColorMap = {
    light: "var(--ds-border-focused, ".concat((0, $9ALL1.B100), ")"),
    dark: "var(--ds-border-focused, ".concat((0, $9ALL1.B75), ")")
};
var $4be89cb811b70b40$export$5b33c784b26b1d3f = function getTabPanelFocusColor(mode) {
    return $4be89cb811b70b40$var$tabPanelFocusColorMap[mode];
};

});
parcelRegister("9ALL1", function(module, exports) {
$parcel$export(module.exports, "B75", function () { return $6fbc857b7a544148$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $6fbc857b7a544148$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $6fbc857b7a544148$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $6fbc857b7a544148$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $6fbc857b7a544148$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N30", function () { return $6fbc857b7a544148$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N500", function () { return $6fbc857b7a544148$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N30A", function () { return $6fbc857b7a544148$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $6fbc857b7a544148$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN0", function () { return $6fbc857b7a544148$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $6fbc857b7a544148$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5RIxF = parcelRequire("5RIxF");
var $6fbc857b7a544148$export$4b84fd0e2c617bd = '#FFEBE6';
var $6fbc857b7a544148$export$b34b069eff244586 = '#FFBDAD';
var $6fbc857b7a544148$export$be802dd0d8b57f35 = '#FF8F73';
var $6fbc857b7a544148$export$60847d42f9da92a6 = '#FF7452';
var $6fbc857b7a544148$export$4a7404f376229999 = '#FF5630';
var $6fbc857b7a544148$export$2010d0fb4295b346 = '#DE350B';
var $6fbc857b7a544148$export$2837b5a1a71d5c02 = '#BF2600';
var $6fbc857b7a544148$export$8d9596b529bbb9cf = '#FFFAE6';
var $6fbc857b7a544148$export$41060a744ab0b7ae = '#FFF0B3';
var $6fbc857b7a544148$export$1cc05bbbf340e559 = '#FFE380';
var $6fbc857b7a544148$export$5aae31392d72caaa = '#FFC400';
var $6fbc857b7a544148$export$c6930421db9fa514 = '#FFAB00';
var $6fbc857b7a544148$export$59619663aa6500fb = '#FF991F';
var $6fbc857b7a544148$export$874739ea9e379ab6 = '#FF8B00';
var $6fbc857b7a544148$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $6fbc857b7a544148$export$69a3bf21b9686c2b = '#ABF5D1';
var $6fbc857b7a544148$export$afbce1382ec95f73 = '#79F2C0';
var $6fbc857b7a544148$export$747d86715d4175de = '#57D9A3';
var $6fbc857b7a544148$export$940e1f69e873f202 = '#36B37E';
var $6fbc857b7a544148$export$a49394138f7b8e85 = '#00875A';
var $6fbc857b7a544148$export$6fa04827ac68a4fb = '#006644';
var $6fbc857b7a544148$export$226de0355ed012f8 = '#DEEBFF';
var $6fbc857b7a544148$export$8c13c2ee36917869 = '#B3D4FF';
var $6fbc857b7a544148$export$ecfc1dff386a3e7a = '#4C9AFF';
var $6fbc857b7a544148$export$215b7063051591f1 = '#2684FF';
var $6fbc857b7a544148$export$e62e8919cca44969 = '#0065FF';
var $6fbc857b7a544148$export$b3de0ae08da2ce64 = '#0052CC';
var $6fbc857b7a544148$export$a6ee3d71bc067634 = '#0747A6';
var $6fbc857b7a544148$export$363e4475840015bb = '#EAE6FF';
var $6fbc857b7a544148$export$4b0a4417ed59760f = '#C0B6F2';
var $6fbc857b7a544148$export$6011520a64d9a187 = '#998DD9';
var $6fbc857b7a544148$export$a7175d4e9206bc80 = '#8777D9';
var $6fbc857b7a544148$export$b48405b95304b5a1 = '#6554C0';
var $6fbc857b7a544148$export$c71e4279dd54a18d = '#5243AA';
var $6fbc857b7a544148$export$147899de772240ec = '#403294';
var $6fbc857b7a544148$export$2cf711fe14c66f06 = '#E6FCFF';
var $6fbc857b7a544148$export$7a8f4d33f6f9772c = '#B3F5FF';
var $6fbc857b7a544148$export$776c9c497ef08533 = '#79E2F2';
var $6fbc857b7a544148$export$69cb3ca10c1e330e = '#00C7E6';
var $6fbc857b7a544148$export$9dc1ef0f3f48059b = '#00B8D9';
var $6fbc857b7a544148$export$7c835c78b6fcdef8 = '#00A3BF';
var $6fbc857b7a544148$export$6036577f95c3877e = '#008DA6';
var $6fbc857b7a544148$export$29a4f05edc054374 = '#FFFFFF';
var $6fbc857b7a544148$export$e655ef011c4aa1a2 = '#FAFBFC';
var $6fbc857b7a544148$export$9fdfb749e33cdf97 = '#F4F5F7';
var $6fbc857b7a544148$export$3e51e8f1440314ba = '#EBECF0';
var $6fbc857b7a544148$export$1ce2d1575d444ceb = '#DFE1E6';
var $6fbc857b7a544148$export$8754fc7e6d8b3000 = '#C1C7D0';
var $6fbc857b7a544148$export$c2e91cbeada39b8b = '#B3BAC5';
var $6fbc857b7a544148$export$5f71e19f3a7ad9de = '#A5ADBA';
var $6fbc857b7a544148$export$eaa8c8a70ac22806 = '#97A0AF';
var $6fbc857b7a544148$export$7c87d337fb91a97d = '#8993A4';
var $6fbc857b7a544148$export$d6447c357493214f = '#7A869A';
var $6fbc857b7a544148$export$f563ee71e9ee74cd = '#6B778C';
var $6fbc857b7a544148$export$e2ef2124cf4024b1 = '#5E6C84';
var $6fbc857b7a544148$export$eece5f492e429f08 = '#505F79';
var $6fbc857b7a544148$export$c39c0fe0f26207ae = '#42526E';
var $6fbc857b7a544148$export$7090862dc3038a9f = '#344563';
var $6fbc857b7a544148$export$ad0bacf983b7ddaa = '#253858';
var $6fbc857b7a544148$export$7d61b15e0da132af = '#172B4D';
var $6fbc857b7a544148$export$fbda843f0a27fe96 = '#091E42';
var $6fbc857b7a544148$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $6fbc857b7a544148$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $6fbc857b7a544148$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $6fbc857b7a544148$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $6fbc857b7a544148$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $6fbc857b7a544148$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $6fbc857b7a544148$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $6fbc857b7a544148$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $6fbc857b7a544148$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $6fbc857b7a544148$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $6fbc857b7a544148$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $6fbc857b7a544148$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $6fbc857b7a544148$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $6fbc857b7a544148$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $6fbc857b7a544148$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $6fbc857b7a544148$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $6fbc857b7a544148$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $6fbc857b7a544148$export$2f6319cf7d736c2a = '#E6EDFA';
var $6fbc857b7a544148$export$95126bc8884d6634 = '#DCE5F5';
var $6fbc857b7a544148$export$8338d8c35d44ff1 = '#CED9EB';
var $6fbc857b7a544148$export$5368d76ae4fbbda7 = '#B8C7E0';
var $6fbc857b7a544148$export$9f0a771d16ec8d36 = '#ABBBD6';
var $6fbc857b7a544148$export$abcf8c38338b4aa5 = '#9FB0CC';
var $6fbc857b7a544148$export$97e81faa16a182c7 = '#8C9CB8';
var $6fbc857b7a544148$export$bfe21c59123ecf33 = '#7988A3';
var $6fbc857b7a544148$export$ee82aa2ea6a1558 = '#67758F';
var $6fbc857b7a544148$export$682927c6ed76be02 = '#56637A';
var $6fbc857b7a544148$export$91fd9994c5be9757 = '#455166';
var $6fbc857b7a544148$export$d281fbfe3cff2df6 = '#3B475C';
var $6fbc857b7a544148$export$3902c91d8b98a753 = '#313D52';
var $6fbc857b7a544148$export$8e8133c1ba5845b5 = '#283447';
var $6fbc857b7a544148$export$33ff357f6620b39 = '#202B3D';
var $6fbc857b7a544148$export$633847cf062b69e0 = '#1B2638';
var $6fbc857b7a544148$export$9776a6e503bdbf76 = '#121A29';
var $6fbc857b7a544148$export$6c813d5160dff5db = '#0E1624';
var $6fbc857b7a544148$export$3d4f271a500072a = '#0D1424';
var $6fbc857b7a544148$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $6fbc857b7a544148$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $6fbc857b7a544148$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $6fbc857b7a544148$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $6fbc857b7a544148$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $6fbc857b7a544148$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $6fbc857b7a544148$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $6fbc857b7a544148$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $6fbc857b7a544148$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $6fbc857b7a544148$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $6fbc857b7a544148$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $6fbc857b7a544148$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $6fbc857b7a544148$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $6fbc857b7a544148$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $6fbc857b7a544148$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $6fbc857b7a544148$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $6fbc857b7a544148$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $6fbc857b7a544148$export$8ce1fd94bee2f412 = (0, $5RIxF.default)({
    light: "var(--ds-surface, ".concat($6fbc857b7a544148$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($6fbc857b7a544148$export$633847cf062b69e0, ")")
});
var $6fbc857b7a544148$export$b861914ea877b580 = (0, $5RIxF.default)({
    light: "var(--ds-background-selected, ".concat($6fbc857b7a544148$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($6fbc857b7a544148$export$8c13c2ee36917869, ")")
});
var $6fbc857b7a544148$export$3f1b020df94387af = (0, $5RIxF.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($6fbc857b7a544148$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($6fbc857b7a544148$export$d281fbfe3cff2df6, ")")
});
var $6fbc857b7a544148$export$c0183dbab98ca63e = (0, $5RIxF.default)({
    light: "var(--ds-surface-overlay, ".concat($6fbc857b7a544148$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($6fbc857b7a544148$export$8e8133c1ba5845b5, ")")
});
var $6fbc857b7a544148$export$6f093cfa640b7166 = (0, $5RIxF.default)({
    light: "var(--ds-text, ".concat($6fbc857b7a544148$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($6fbc857b7a544148$export$5368d76ae4fbbda7, ")")
});
var $6fbc857b7a544148$export$42f8e9c698766e7a = (0, $5RIxF.default)({
    light: "var(--ds-text, ".concat($6fbc857b7a544148$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($6fbc857b7a544148$export$5368d76ae4fbbda7, ")")
});
var $6fbc857b7a544148$export$c2d157ca1c34b6e3 = (0, $5RIxF.default)({
    light: "var(--ds-text-selected, ".concat($6fbc857b7a544148$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($6fbc857b7a544148$export$b3de0ae08da2ce64, ")")
});
var $6fbc857b7a544148$export$1905ba28d7cf066f = (0, $5RIxF.default)({
    light: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$97e81faa16a182c7, ")")
});
var $6fbc857b7a544148$export$bd9002130d306d39 = (0, $5RIxF.default)({
    light: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$bfe21c59123ecf33, ")")
});
var $6fbc857b7a544148$export$46e4a324ac90507f = (0, $5RIxF.default)({
    light: "var(--ds-text, ".concat($6fbc857b7a544148$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($6fbc857b7a544148$export$5368d76ae4fbbda7, ")")
});
var $6fbc857b7a544148$export$79f3f2b82beb0d36 = (0, $5RIxF.default)({
    light: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$97e81faa16a182c7, ")")
});
var $6fbc857b7a544148$export$7bb0d5c671655cc4 = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$9fdfb749e33cdf97,
    dark: $6fbc857b7a544148$export$8e8133c1ba5845b5
});
var $6fbc857b7a544148$export$9c30223ca0a664fb = (0, $5RIxF.default)({
    light: "var(--ds-link, ".concat($6fbc857b7a544148$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($6fbc857b7a544148$export$ecfc1dff386a3e7a, ")")
});
var $6fbc857b7a544148$export$7ed258b0728b004b = (0, $5RIxF.default)({
    light: "var(--ds-link-pressed, ".concat($6fbc857b7a544148$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($6fbc857b7a544148$export$215b7063051591f1, ")")
});
var $6fbc857b7a544148$export$dfa920d8decc8a59 = (0, $5RIxF.default)({
    light: "var(--ds-link-pressed, ".concat($6fbc857b7a544148$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($6fbc857b7a544148$export$ecfc1dff386a3e7a, ")")
});
var $6fbc857b7a544148$export$6069e6ad5c78f632 = (0, $5RIxF.default)({
    light: "var(--ds-border-focused, ".concat($6fbc857b7a544148$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($6fbc857b7a544148$export$215b7063051591f1, ")")
});
var $6fbc857b7a544148$export$9ad721cf3b3debe0 = (0, $5RIxF.default)({
    light: "var(--ds-background-brand-bold, ".concat($6fbc857b7a544148$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($6fbc857b7a544148$export$ecfc1dff386a3e7a, ")")
});
var $6fbc857b7a544148$export$2aa0182783e7e9de = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$b3de0ae08da2ce64,
    dark: $6fbc857b7a544148$export$ecfc1dff386a3e7a
});
var $6fbc857b7a544148$export$8bf7dff220b82b4a = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$9dc1ef0f3f48059b,
    dark: $6fbc857b7a544148$export$69cb3ca10c1e330e
});
var $6fbc857b7a544148$export$e13cce2a2d16a9d4 = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$b48405b95304b5a1,
    dark: $6fbc857b7a544148$export$6011520a64d9a187
});
var $6fbc857b7a544148$export$a90204d1394caf30 = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$4a7404f376229999,
    dark: $6fbc857b7a544148$export$4a7404f376229999
});
var $6fbc857b7a544148$export$594c5a8758200c32 = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$c6930421db9fa514,
    dark: $6fbc857b7a544148$export$c6930421db9fa514
});
var $6fbc857b7a544148$export$955a2ebd2fb142ae = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$940e1f69e873f202,
    dark: $6fbc857b7a544148$export$940e1f69e873f202
});
var $6fbc857b7a544148$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($6fbc857b7a544148$export$8d43898f60b96a82, ")");
};

});
parcelRegister("5RIxF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44547421330cbf41$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $e8i1O = parcelRequire("e8i1O");
// Unpack custom variants, and get correct value for the current theme
function $44547421330cbf41$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $e8i1O.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $44547421330cbf41$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $44547421330cbf41$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $e8i1O.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("e8i1O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a49fcc18574d5592$export$2e2bcd8739ae039; });

var $f3iYW = parcelRequire("f3iYW");
function $a49fcc18574d5592$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $f3iYW.CHANNEL) in props.theme) return props.theme[0, $f3iYW.CHANNEL];
        else if ('mode' in props.theme && (0, $f3iYW.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $f3iYW.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("f3iYW", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $af55dc3c37cd9861$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $af55dc3c37cd9861$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $af55dc3c37cd9861$export$6ba72c8346b4c57e; });

var $igwZj = parcelRequire("igwZj");

var $9ALL1 = parcelRequire("9ALL1");
var $af55dc3c37cd9861$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $af55dc3c37cd9861$export$c93026a968943f95 = 'light';
var $af55dc3c37cd9861$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $af55dc3c37cd9861$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $af55dc3c37cd9861$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $af55dc3c37cd9861$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $af55dc3c37cd9861$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $af55dc3c37cd9861$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $af55dc3c37cd9861$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $af55dc3c37cd9861$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $9ALL1.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $af55dc3c37cd9861$export$6d8204c2cb2e06b8() / 4;
    (0, $igwZj.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $af55dc3c37cd9861$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $af55dc3c37cd9861$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $af55dc3c37cd9861$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $igwZj.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $af55dc3c37cd9861$export$ba1d834b86d72a09 = $af55dc3c37cd9861$export$a1b3edb637fb4f35;
var $af55dc3c37cd9861$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $9ALL1.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $9ALL1.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $9ALL1.N30A), ")")
            }
        }
    };
};

});
parcelRegister("igwZj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4c34f586c8959d0$export$2e2bcd8739ae039; });

var $2hYAn = parcelRequire("2hYAn");

var $7t0tI = parcelRequire("7t0tI");
function $d4c34f586c8959d0$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $2hYAn.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $d4c34f586c8959d0$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("2hYAn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1aac2a57efff957f$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $1aac2a57efff957f$var$printed = {};
function $1aac2a57efff957f$export$2e2bcd8739ae039(message) {
    if ($1aac2a57efff957f$var$printed[message]) return;
    $1aac2a57efff957f$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});








parcelRegister("34TA1", function(module, exports) {
$parcel$export(module.exports, "onMouseDownBlur", function () { return $23dcdbd655f15e6a$export$1aedf39a68fc0142; });
// Prevent a focus ring if clicked
var $23dcdbd655f15e6a$export$1aedf39a68fc0142 = function onMouseDownBlur(e) {
    var currentTarget = e.currentTarget;
    var focusedDuringMouseDown = currentTarget === document.activeElement;
    requestAnimationFrame(function() {
        if (focusedDuringMouseDown && currentTarget !== document.activeElement && document.body.contains(currentTarget)) {
            currentTarget.focus();
            return;
        }
        if (!focusedDuringMouseDown && document.body.contains(currentTarget)) currentTarget.blur();
    });
};

});


parcelRegister("9T4IS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $732ce9f1d0fdbdd6$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $hdvAu = parcelRequire("hdvAu");

var $6dioi = parcelRequire("6dioi");

var $btjy5 = parcelRequire("btjy5");

var $bJ4Xk = parcelRequire("bJ4Xk");

var $34TA1 = parcelRequire("34TA1");
var $732ce9f1d0fdbdd6$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    padding: "var(--ds-space-0, 0px)",
    position: 'relative'
});
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $732ce9f1d0fdbdd6$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useGlobalTheme = (0, $hdvAu.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var _useTabList = (0, $6dioi.useTabList)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $1oC0p.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $1oC0p.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var tabListStyles = (0, $1oC0p.useMemo)(function() {
        return (0, $bJ4Xk.getTabListStyles)(mode);
    }, [
        mode
    ]);
    var selectTabByIndex = (0, $1oC0p.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            var _newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        var modifier = e.key === 'ArrowRight' ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $1oC0p.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return (0, $3dJ4i.jsx)((0, $btjy5.TabContext).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onMouseDown: (0, $34TA1.onMouseDownBlur),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: "".concat(tabsId, "-").concat(index),
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    (0, $3dJ4i.jsx)("div", {
        role: "tablist",
        ref: ref,
        css: [
            $732ce9f1d0fdbdd6$var$baseStyles,
            tabListStyles
        ]
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    })));
};
var $732ce9f1d0fdbdd6$export$2e2bcd8739ae039 = $732ce9f1d0fdbdd6$var$TabList;

});
parcelRegister("6dioi", function(module, exports) {
$parcel$export(module.exports, "useTab", function () { return $48623902a0996682$export$fdf4756d5b8ef90a; });
$parcel$export(module.exports, "useTabList", function () { return $48623902a0996682$export$773e389e644c5874; });
$parcel$export(module.exports, "useTabPanel", function () { return $48623902a0996682$export$fae0121b5afe572d; });

var $1oC0p = parcelRequire("1oC0p");

var $btjy5 = parcelRequire("btjy5");
var $48623902a0996682$export$fdf4756d5b8ef90a = function useTab() {
    var tabData = (0, $1oC0p.useContext)((0, $btjy5.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
var $48623902a0996682$export$773e389e644c5874 = function useTabList() {
    var tabListData = (0, $1oC0p.useContext)((0, $btjy5.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
var $48623902a0996682$export$fae0121b5afe572d = function useTabPanel() {
    var tabPanelData = (0, $1oC0p.useContext)((0, $btjy5.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});



//# sourceMappingURL=enterprise-contact-sales-page.cec17310.js.map
